import { render, staticRenderFns } from "./TaskBox.vue?vue&type=template&id=653ec377&scoped=true&"
import script from "./TaskBox.vue?vue&type=script&lang=js&"
export * from "./TaskBox.vue?vue&type=script&lang=js&"
import style0 from "./TaskBox.vue?vue&type=style&index=0&id=653ec377&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653ec377",
  null
  
)

export default component.exports